import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { XmDirectivesModule, XmDropdownModule, XmPreloaderModule, XmSidebarModule, XmButtonModule } from '@optek/xm-bootstrap';
import { BreadcrumbModule } from './breadcrumb/breadcrumb.module';
import { HeaderComponent } from './header.component';
import { LeftToggleComponent } from './left-toggle/left-toggle.component';
import { LogoComponent } from './logo/logo.component';
import { ProfileNotificationComponent } from './profile/profile-notification/profile-notification.component';
import { ProfileComponent } from './profile/proflie.component';
import { HeaderService } from './header.service';
@NgModule({
    imports: [
        BreadcrumbModule,
        BrowserModule,
        CommonModule,
        FormsModule,
        RouterModule,
        XmDirectivesModule,
        XmDropdownModule,
        XmPreloaderModule,
        XmSidebarModule,
        XmButtonModule
    ],
    declarations: [
        LogoComponent,
        HeaderComponent,
        LeftToggleComponent,
        ProfileComponent,
        ProfileNotificationComponent
    ],
    exports: [
        HeaderComponent
    ],
    providers: [
        HeaderService
    ]
})
export class HeaderModule { }
